import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FlowProvider } from "@/flowStore";
import Welcome from "@/pages/Welcome";
import Capture from "@/pages/Capture";
import Preview from "@/pages/Preview";
import FormPage from "@/pages/FormPage";
import Success from "@/pages/Success";
import Admin from "@/pages/Admin";
import "@/App.css";

function App() {
  return (
    <FlowProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/capture" element={<Capture />} />
          <Route path="/preview" element={<Preview />} />
          <Route path="/form" element={<FormPage />} />
          <Route path="/success" element={<Success />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </FlowProvider>
  );
}

export default App;
